export const onlyDeliveryAddresses = addressContainer => addressContainer.addressType === 'delivery';

export const onlyBillingAddresses = addressContainer => addressContainer.addressType === 'billing';
